export default __webpack_public_path__ + "static/media/start-group-chat-icon.a6cf70ce.svg";